<script lang="ts">
  import Skeleton from './Skeleton.svelte';
</script>

<div class="bg-bg-canvas border border-border-default rounded-lg p-4 shadow-sm">
  <div class="flex items-center space-x-3 mb-3">
    <Skeleton className="w-10 h-10 rounded-full" />
    <div class="flex-1">
      <Skeleton className="h-4 w-3/4 mb-2" />
      <Skeleton className="h-3 w-1/2" />
    </div>
  </div>
  <Skeleton className="h-20 w-full" />
</div>
